import { lazy } from 'react';

// ============================================
// CHUNK: operations (MUM, RM, Director, VP)
// ============================================
const MainDashboard = lazy(() => import(/* webpackChunkName: "operations" */ "../pages/Dashboard/MainDashboard"));
const PeoplePlan = lazy(() => import(/* webpackChunkName: "operations" */ "../pages/PeoplePlan/PeoplePlan"));
const EmployeeProfile = lazy(() => import(/* webpackChunkName: "operations" */ "../pages/PeoplePlan/EmployeeProfile"));

// ============================================
// CHUNK: tickets (shared - all roles)
// ============================================
const CRMTickets = lazy(() => import(/* webpackChunkName: "tickets" */ "../pages/HR/CRM/CRMTickets"));
const TACRMTickets = lazy(() => import(/* webpackChunkName: "tickets" */ "../pages/TA/TACRMTickets"));
const TicketDetailRedirect = lazy(() => import(/* webpackChunkName: "tickets" */ "../pages/HR/CRM/TicketDetailRedirect"));
const MyApprovals = lazy(() => import(/* webpackChunkName: "tickets" */ "../pages/HR/CRM/MyApprovals"));

// ============================================
// CHUNK: rm (RM, HR, Admin)
// ============================================
const RMCRMTickets = lazy(() => import(/* webpackChunkName: "tickets" */ "../pages/RM/RMCRMTickets"));
const RMToDoTickets = lazy(() => import(/* webpackChunkName: "rm" */ "../pages/RM/RMToDoTickets"));
const RMMyApprovals = lazy(() => import(/* webpackChunkName: "rm" */ "../pages/RM/RMMyApprovals"));

// ============================================
// CHUNK: ld-crm (LD, Admin)
// ============================================
const LDCRMTickets = lazy(() => import(/* webpackChunkName: "tickets" */ "../pages/LD/LDCRMTickets"));
const LDToDoTickets = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/LDToDoTickets"));
const LDMyApprovals = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/LDMyApprovals"));

// ============================================
// CHUNK: it (IT, Admin)
// ============================================
const ITCRMTickets = lazy(() => import(/* webpackChunkName: "tickets" */ "../pages/IT/ITCRMTickets"));
const ITToDoTickets = lazy(() => import(/* webpackChunkName: "it" */ "../pages/IT/ITToDoTickets"));
const ITMyApprovals = lazy(() => import(/* webpackChunkName: "it" */ "../pages/IT/ITMyApprovals"));

// ============================================
// CHUNK: hr (HR, Admin only)
// ============================================
const HRDashboard = lazy(() => import(/* webpackChunkName: "hr" */ "../pages/HR/HRDashboard"));
const ToDoTickets = lazy(() => import(/* webpackChunkName: "hr" */ "../pages/HR/CRM/ToDoTickets"));

// ============================================
// CHUNK: ta (TA, Admin only)
// ============================================
const TADashboard = lazy(() => import(/* webpackChunkName: "ta" */ "../pages/TA/TADashboard"));
const TAToDoTickets = lazy(() => import(/* webpackChunkName: "ta" */ "../pages/TA/TAToDoTickets"));
const Jobs = lazy(() => import(/* webpackChunkName: "ta" */ "../pages/TA/Jobs"));
const CandidateTracker = lazy(() => import(/* webpackChunkName: "ta" */ "../pages/TA/CandidateTracker"));
const NewHires = lazy(() => import(/* webpackChunkName: "ta" */ "../pages/TA/NewHires"));
const NewHireTracker = lazy(() => import(/* webpackChunkName: "hr" */ "../pages/TA/NewHireTraining/NewHireTraining"));
const HiresDashboard = lazy(() => import(/* webpackChunkName: "ta" */ "../pages/TA/TA Dashboards/hires/HiresDashboard"));

// ============================================
// CHUNK: ld (LD, LD_Director, Admin only)
// ============================================
const LDDashboard = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/LDDashboard"));
const WeeklyCheckins = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/WeeklyCheckins"));
const MITTracker = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/MITTracker"));
const CertifiedTraining = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/CertifiedTraining"));
const BusinessSupportPlan = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/BusinessSupportPlan"));
const MITProficiency = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/MITProficiency"));
const DepositoryFiles = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/DepositoryFiles"));
const WindowReadinessResults = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/WindowReadinessResults/WindowReadinessResults"));
const ComparisonResults = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/ComparisonResults/ComparisonResults"));
const GoalsOKRs = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/PeoplePulse/Goals/GoalsOKRs"));
const OneOnOneMeetings = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/PeoplePulse/OneOnOne/OneOnOneMeetings"));
const PerformanceReviews = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/PeoplePulse/Reviews/PerformanceReviews"));
const FeedbackRecognition = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/PeoplePulse/Feedback/FeedbackRecognition"));
const TasksActionItems = lazy(() => import(/* webpackChunkName: "ld" */ "../pages/LD/PeoplePulse/Tasks/TasksActionItems"));

// ============================================
// CHUNK: loa (HR, Admin only)
// ============================================
const LOADashboard = lazy(() => import(/* webpackChunkName: "loa" */ "../pages/LOA/LOADashboard"));
const LOACaseList = lazy(() => import(/* webpackChunkName: "loa" */ "../pages/LOA/LOACaseList"));
const LOANewCase = lazy(() => import(/* webpackChunkName: "loa" */ "../pages/LOA/LOANewCase"));
const LOACaseDetail = lazy(() => import(/* webpackChunkName: "loa" */ "../pages/LOA/LOACaseDetail"));
const LOACalendar = lazy(() => import(/* webpackChunkName: "loa" */ "../pages/LOA/LOACalendar"));
const LOAReports = lazy(() => import(/* webpackChunkName: "loa" */ "../pages/LOA/LOAReports"));

// ============================================
// CHUNK: settings (Admin only)
// ============================================
const Settings = lazy(() => import(/* webpackChunkName: "settings" */ "../pages/Settings/Settings"));

// ============================================
// CHUNK: admin-analytics (Admin only)
// ============================================
const AnalyticsDashboard = lazy(() => import(/* webpackChunkName: "admin-analytics" */ "../pages/Admin/Analytics/AnalyticsDashboard"));
const OperationsMonitor = lazy(() => import(/* webpackChunkName: "admin-analytics" */ "../pages/Admin/Analytics/OperationsMonitor"));
const ErrorTracking = lazy(() => import(/* webpackChunkName: "admin-analytics" */ "../pages/Admin/Analytics/ErrorTracking"));
const TAOperationsMonitor = lazy(() => import(/* webpackChunkName: "admin-analytics" */ "../pages/Admin/Analytics/TAOperationsMonitor"));
const EmailHealth = lazy(() => import(/* webpackChunkName: "admin-analytics" */ "../pages/Admin/Analytics/EmailHealth"));
const SchedulerHealth = lazy(() => import(/* webpackChunkName: "admin-analytics" */ "../pages/Admin/Analytics/SchedulerHealth"));

// Admin-analytics pages are restricted to this email allowlist.
// KEEP IN SYNC WITH backend/middleware/analyticsOwner.js (reads ANALYTICS_OWNER_EMAILS env).
export const ANALYTICS_OWNER_EMAILS = [
  "lbarbosa@cafuamanagement.com",
];

export const ROLES = {
  ADMIN: "admin",
  DIRECTOR: "director",
  VP: "vp",
  MUM: "mum",
  RM: "rm",
  RMA: "rma",
  HR: "hr",
  HR_DIRECTOR: "hr_director",
  CB: "cb",
  TA: "ta",
  LD: "ld",
  LD_DIRECTOR: "ld_director",
  IT: "it",
};

/**
 * Returns the default home route for a given role
 * @param {string} role - User role (lowercase)
 * @returns {string} - Default route path for the role
 */
export const getDefaultRouteForRole = (role) => {
  const normalizedRole = role?.toLowerCase();
  switch (normalizedRole) {
    case ROLES.HR:
    case ROLES.HR_DIRECTOR:
    // C&B staff land on /hr like the rest of the HR family. They hold
    // users.role='hr' today, so without this case the move to 'cb' would
    // silently change where they land after login.
    case ROLES.CB:
      return "/hr";
    case ROLES.TA:
      return "/ta";
    case ROLES.LD:
    case ROLES.LD_DIRECTOR:
      return "/ld";
    case ROLES.RMA:
      return "/rm/crm/tickets";
    case ROLES.IT:
      return "/it/crm/tickets";
    default:
      return "/dashboard";
  }
};

export const pages = [
  {
    name: "Dashboard",
    path: "/dashboard",
    component: MainDashboard,
    allowed: [ROLES.ADMIN, ROLES.DIRECTOR, ROLES.VP, ROLES.MUM, ROLES.RM, ROLES.LD_DIRECTOR, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB],
  },
  {
    name: "People Plan",
    path: "/peopleplan",
    component: PeoplePlan,
    allowed: [ROLES.ADMIN, ROLES.DIRECTOR, ROLES.VP, ROLES.MUM, ROLES.RM, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB, ROLES.LD_DIRECTOR],
  },

  /* ---------------- HR ---------------- */
  {
    name: "hr",
    allowed: [ROLES.ADMIN, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB, ROLES.MUM, ROLES.RM],
    children: [
      { name: "HR Dashboard", path: "/hr", component: HRDashboard, allowed: [ROLES.ADMIN, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB] },
      { name: "HR Requests", path: "/hr/crm/tickets", component: CRMTickets, allowed: Object.values(ROLES) },
      { name: "To Do Tickets", path: "/hr/crm/todo-tickets", component: ToDoTickets, allowed: [ROLES.ADMIN, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB] },
      { name: "New Hire Tracker", path: "/hr/new-hire-tracker", component: NewHireTracker, allowed: [ROLES.ADMIN, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB] },
    ]
  },

  /* ---------------- TA ---------------- */
  {
    name: "ta",
    allowed: [ROLES.ADMIN, ROLES.TA, ROLES.MUM, ROLES.RM],
    children: [
      { name: "TA Dashboard", path: "/ta", component: TADashboard, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "Hires Dashboard", path: "/recruiting/hires", component: HiresDashboard, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "TA Requests", path: "/ta/crm/tickets", component: TACRMTickets, allowed: Object.values(ROLES) },
      { name: "To Do Tickets", path: "/ta/requests", component: TAToDoTickets, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "Job Tracker", path: "/ta/jobs", component: Jobs, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "Candidate Tracker", path: "/ta/candidates", component: CandidateTracker, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "Onboarding", path: "/ta/newhires", component: NewHires, allowed: [ROLES.ADMIN, ROLES.TA] },
    ]
  },

  /* ---------------- Risk Management ---------------- */
  {
    name: "rm",
    allowed: Object.values(ROLES),
    children: [
      { name: "RM Requests", path: "/rm/crm/tickets", component: RMCRMTickets, allowed: Object.values(ROLES) },
      { name: "To Do Tickets", path: "/rm/crm/todo-tickets", component: RMToDoTickets, allowed: [ROLES.ADMIN, ROLES.RMA] },
    ]
  },

  /* ---------------- L&D ---------------- */
  {
    name: "ld",
    allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR],
    children: [
      { name: "L&D Dashboard", path: "/ld", component: LDDashboard, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "L&D Requests", path: "/ld/crm/tickets", component: LDCRMTickets, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "To Do Tickets", path: "/ld/crm/todo-tickets", component: LDToDoTickets, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "MIT Tracker", path: "/ld/mit-tracker", component: MITTracker, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Certified Training", path: "/ld/certified-training", component: CertifiedTraining, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Business Support Plan", path: "/ld/business-support-plan", component: BusinessSupportPlan, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "MIT Proficiency Checklist", path: "/ld/mit-proficiency-checklist", component: MITProficiency, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Weekly Check-ins (Legacy)", path: "/ld/checkins", component: WeeklyCheckins, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Depository Files", path: "/ld/files", component: DepositoryFiles, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Window Readiness Results", path: "/ld/window-readiness", component: WindowReadinessResults, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Center vs Workpulse Comparison", path: "/ld/comparison", component: ComparisonResults, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR, ROLES.VP, ROLES.DIRECTOR, ROLES.MUM, ROLES.RM] },
      { name: "Goals & OKRs", path: "/peoplepulse/goals", component: GoalsOKRs, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "1-on-1 Meetings", path: "/peoplepulse/one-on-one", component: OneOnOneMeetings, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Performance Reviews", path: "/peoplepulse/reviews", component: PerformanceReviews, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Feedback & Recognition", path: "/peoplepulse/feedback", component: FeedbackRecognition, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Tasks & Action Items", path: "/peoplepulse/tasks", component: TasksActionItems, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
    ]
  },

  /* ---------------- IT ---------------- */
  {
    name: "it",
    allowed: Object.values(ROLES),
    children: [
      { name: "IT Requests", path: "/it/crm/tickets", component: ITCRMTickets, allowed: Object.values(ROLES) },
      { name: "To Do Tickets", path: "/it/crm/todo-tickets", component: ITToDoTickets, allowed: [ROLES.ADMIN, ROLES.IT] },
    ]
  },

  /* ---------------- LOA ---------------- */
  {
    name: "loa",
    allowed: [ROLES.ADMIN, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB],
    children: [
      { name: "LOA Dashboard", path: "/loa", component: LOADashboard, allowed: [ROLES.ADMIN, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB] },
      { name: "Cases", path: "/loa/cases", component: LOACaseList, allowed: [ROLES.ADMIN, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB] },
      { name: "New Case", path: "/loa/cases/new", component: LOANewCase, allowed: [ROLES.ADMIN, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB] },
      { name: "Calendar", path: "/loa/calendar", component: LOACalendar, allowed: [ROLES.ADMIN, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB] },
      { name: "Reports", path: "/loa/reports", component: LOAReports, allowed: [ROLES.ADMIN, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB] },
    ]
  },

  /* ---------------- Dynamic Routes ---------------- */
  {
    name: "Employee Profile",
    path: "/employee/:id",
    component: EmployeeProfile,
    allowed: Object.values(ROLES),
    isDynamic: true,
  },
  {
    name: "Ticket Detail Redirect",
    path: "/hr/crm/tickets/:ticketNumber",
    component: TicketDetailRedirect,
    allowed: Object.values(ROLES),
    isDynamic: true,
  },
  {
    name: "My Approvals",
    path: "/hr/crm/approvals/:ticketNumber?",
    component: MyApprovals,
    allowed: Object.values(ROLES),
    isDynamic: true,
  },
  {
    name: "RM My Approvals",
    path: "/rm/crm/approvals/:ticketNumber?",
    component: RMMyApprovals,
    allowed: [ROLES.ADMIN, ROLES.RMA],
    isDynamic: true,
  },
  {
    name: "L&D My Approvals",
    path: "/ld/crm/approvals/:ticketNumber?",
    component: LDMyApprovals,
    allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR],
    isDynamic: true,
  },
  {
    name: "IT My Approvals",
    path: "/it/crm/approvals/:ticketNumber?",
    component: ITMyApprovals,
    allowed: [ROLES.ADMIN, ROLES.IT],
    isDynamic: true,
  },
  {
    name: "LOA Case Detail",
    path: "/loa/cases/:id",
    component: LOACaseDetail,
    allowed: [ROLES.ADMIN, ROLES.HR, ROLES.HR_DIRECTOR, ROLES.CB],
    isDynamic: true,
  },
  /* ---------------- Settings ---------------- */
  {
    name: "Settings",
    path: "/settings",
    component: Settings,
    allowed: [ROLES.ADMIN, ROLES.IT],
  },
  {
    name: "Analytics",
    path: "/admin/analytics",
    component: AnalyticsDashboard,
    allowed: [ROLES.ADMIN],
    allowedEmails: ANALYTICS_OWNER_EMAILS,
  },
  {
    name: "Operations Monitor",
    path: "/admin/operations",
    component: OperationsMonitor,
    allowed: [ROLES.ADMIN],
    allowedEmails: ANALYTICS_OWNER_EMAILS,
  },
  {
    name: "Error Tracking",
    path: "/admin/error-tracking",
    component: ErrorTracking,
    allowed: [ROLES.ADMIN],
    allowedEmails: ANALYTICS_OWNER_EMAILS,
  },
  {
    name: "TA Operations",
    path: "/admin/ta-operations",
    component: TAOperationsMonitor,
    allowed: [ROLES.ADMIN],
    allowedEmails: ANALYTICS_OWNER_EMAILS,
  },
  {
    name: "Email Health",
    path: "/admin/email-health",
    component: EmailHealth,
    allowed: [ROLES.ADMIN],
    allowedEmails: ANALYTICS_OWNER_EMAILS,
  },
  {
    name: "Scheduler Health",
    path: "/admin/scheduler-health",
    component: SchedulerHealth,
    allowed: [ROLES.ADMIN],
    allowedEmails: ANALYTICS_OWNER_EMAILS,
  },
];
